module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/stakeholder-4cb1fa7b466d72591be8057cd7fa7be3.svg";